module.exports = __webpack_public_path__ + "img/bgc19.f492f8a9.png";